export default __webpack_public_path__ + "img/afc2a65b304ae72aa41f8c545d8fe579.png";